<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2378_9328)">
      <rect
        x="4"
        y="8"
        width="8"
        height="6.66667"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.33366 14.6667V12.0001C9.33366 11.2637 8.73671 10.6667 8.00033 10.6667C7.26395 10.6667 6.66699 11.2637 6.66699 12.0001V14.6667"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 8L13.8015 8.67556C14.5201 8.94503 14.6667 9.15656 14.6667 9.924V14.6667H12V8Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.33301 9.924C1.33301 9.15655 1.47959 8.94503 2.19818 8.67556L3.99967 8V14.6667H1.33301V9.924Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.8053 6.33333C11.5422 4.24036 10.0959 2 8 2C5.90407 2 4.45778 4.24036 5.19465 6.33333"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 1.99992V1.33325"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.33301 8.00008V6.66675M10.6663 8.00008V6.66675"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.66699 6.33325H11.3337"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2378_9328">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
